import {useIsDesktop} from './../../../shared/hooks/useIsDesktop';
import {Screens} from './../../../shared/routing/model';
import {NavigationProp, ParamListBase} from '@react-navigation/native';
import {NotificationResponsePayload} from './../../../shared/models/api/notificationResponsePayload';
import * as React from 'react';

export const useNotificationPressHandler = (
  notification: NotificationResponsePayload | null,
  nav: NavigationProp<ParamListBase>,
): null | (() => void) => {
  const isDesktop = useIsDesktop();
  const pressHandler = React.useCallback(() => {
    const id = notification?.referenceId;
    switch (notification?.referenceType) {
      case 'usc':
        nav.navigate(Screens.Profile);
        break;
      case 'application':
        nav.navigate(
          ...(isDesktop
            ? [Screens.ProfileApplications, {'application-id': id}]
            : [Screens.Profile, {screen: Screens.ProfileApplicationsItem, params: {'application-id': id}}]),
        );
        break;
      case 'request':
        nav.navigate(
          ...(isDesktop
            ? [Screens.SupportServiceTopics, {id}]
            : [Screens.SupportServiceTab, {screen: Screens.SupportServiceTopic, params: {id}}]),
        );
        break;
      /*case 'poll':
        nav.navigate(
          ...(isDesktop
            ? [Screens.PollsTypeVoteForm, {pollId: id}]
            : [Screens.PollsMenu, {screen: Screens.PollsTypeVoteForm, params: {pollId: id}}]),
        );
        break;*/
      case 'news':
        nav.navigate(
          ...(isDesktop ? [Screens.NewsArticle, {id}] : [Screens.News, {screen: Screens.NewsArticle, params: {id}}]),
        );
        break;
      case 'socHelp':
        nav.navigate(
          ...(isDesktop
            ? [Screens.PrivilegesServiceDetails, {ssmCode: id}]
            : [Screens.CardServicesMenu, {screen: Screens.PrivilegesServiceDetails, params: {ssmCode: id}}]),
        );
        break;
      case 'ecard':
        nav.navigate(
          ...(isDesktop ? [Screens.TransportService] : [Screens.CardServicesMenu, {screen: Screens.TransportService}]),
        );
        break;
      case 'contact':
        nav.navigate(
          ...(isDesktop ? [Screens.DesktopProfileSettings] : [Screens.Profile, {screen: Screens.ProfileUserContacts}]),
        );
        break;
    }
  }, [notification, isDesktop]);

  return notification?.referenceType === 'request' ? pressHandler : null;
};
